// extracted by mini-css-extract-plugin
module.exports = {"button":"e_wB"};